import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

const infoRowVariants = cva('flex items-center gap-2 rounded-lg px-3 py-2 text-[13px]', {
	variants: {
		tone: {
			neutral: 'border border-border bg-background/50 text-text-muted',
			success: 'bg-accent-green/10 text-accent-green',
			danger: 'bg-danger/10 text-danger',
		},
	},
	defaultVariants: {
		tone: 'neutral',
	},
});

export interface InfoRowProps {
	/** Colore della riga (neutro, successo, pericolo). Default: `neutral`. */
	tone?: VariantProps<typeof infoRowVariants>['tone'];
	/** Icona iniziale; dimensionata e (per il tono neutro) colorata ad accento automaticamente. */
	icon?: React.ReactNode;
	/** Contenuto principale della riga. */
	children: React.ReactNode;
	/** Azione allineata a destra (bottone/link). */
	action?: React.ReactNode;
}

/** Riga informativa/di stato bordata, con icona opzionale e azione finale. */
const InfoRow = ({ icon, children, action, tone }: InfoRowProps) => (
	<div className={infoRowVariants({ tone })}>
		{icon && (
			<span
				className={
					tone === 'neutral' || tone == null
						? 'shrink-0 text-accent [&_svg]:h-3.5 [&_svg]:w-3.5'
						: 'shrink-0 [&_svg]:h-3.5 [&_svg]:w-3.5'
				}
			>
				{icon}
			</span>
		)}
		<span className="min-w-0 flex-1">{children}</span>
		{action && <span className="shrink-0">{action}</span>}
	</div>
);
InfoRow.displayName = 'InfoRow';

export { InfoRow, infoRowVariants };
